import apiService from '../apiService';
import esgConfig from './esgConfig';

const esgService = {
	//fetch questionnaire data
	// retrieveLogon: (request) => {
	// 	return apiService('fetchLogin', esgConfig, request);
	// },
	fetchQuestionnaires: (request) => {
		return apiService('fetchQuestionnaires', esgConfig, request);
	},
	responses: (request) => {
		return apiService('responses', esgConfig, request);
	},
	retrieveQuestionnairesResult: (request) => {
		return apiService('fetchQuestionnairesResult', esgConfig, request);
	},

	//wealth msg api
	fetchQuestionnaires_wealth: (request) => {
		return apiService('fetchQuestionnaires_wealth', esgConfig, request);
	},
	responses_wealth: (request) => {
		return apiService('responses_wealth', esgConfig, request);
	},
	retrieveQuestionnairesResult_wealth: (request) => {
		return apiService('fetchQuestionnairesResult_wealth', esgConfig, request);
	},
	retrieveReportGenerate: (request) => {
		return apiService('retrieveReportGenerate', esgConfig, request);
	},
	retrieveReportDocumnetId: (request, urlParams) => {
		return apiService('retrieveReportDocumnetId', esgConfig, request, urlParams);
	},
	downloadEsgReport: (request) => {
		return apiService('downloadEsgReport', esgConfig, request);
	}
};

export default esgService;
